/**
 * 클라이언트(TS) i18n — 서버가 layouts 에 주입한 #app-i18n JSON(lang `js` 네임스페이스)을
 * 1회 파싱하고 t('dot.path', replace?) 로 조회한다.
 *
 * - 서버 __() 와 동일 철학: 미존재 키는 키 문자열 그대로 반환(개발 중 누락 가시화).
 * - :placeholder 치환 지원 — t('quill.file_too_big', { size: 5, max: 2 }).
 * - 주입 스크립트가 없거나 파싱 실패 시 빈 카탈로그 → 호출부의 자체 영어 폴백이 노출됨.
 */

type Catalog = Record<string, unknown>;

let catalog: Catalog = {};
let loaded = false;

function parseCatalog(): Catalog {
  const el = document.getElementById("app-i18n");
  if (!el) return {};
  try {
    const data = JSON.parse(el.textContent || "{}");
    return data && typeof data === "object" ? (data as Catalog) : {};
  } catch {
    return {};
  }
}

/** #app-i18n 파싱. app 부트스트랩에서 1회 호출(중복 호출은 무시). */
export function init(): void {
  if (loaded) return;
  catalog = parseCatalog();
  loaded = true;
}

function lookup(path: string): string | null {
  if (!loaded) init();
  const keys = path.split(".");
  let cur: unknown = catalog;
  for (const k of keys) {
    if (cur && typeof cur === "object" && k in (cur as Catalog)) {
      cur = (cur as Catalog)[k];
    } else {
      return null;
    }
  }
  return typeof cur === "string" ? cur : null;
}

/**
 * 번역 조회. 미존재 시 path 반환.
 * @param path  dot 경로 (예: "modal.ok", "join.email_required")
 * @param replace  :key → value 치환 맵 (선택)
 */
export function t(path: string, replace?: Record<string, string | number>): string {
  let value = lookup(path);
  if (value === null) return path;
  if (replace) {
    for (const k of Object.keys(replace)) {
      value = value.replace(new RegExp(":" + k, "g"), String(replace[k]));
    }
  }
  return value;
}

export const I18n = { init, t };
